/** @jsxImportSource @emotion/react */

import { Helmet, HelmetProvider } from 'react-helmet-async';

type MetadataProps = {
  title: string;
  description: string;
  imageSrc: string;
};

export const Metadata = ({ description, imageSrc, title }: MetadataProps) => {
  const publicUrl = 'https://holiday.habaneroconsulting.com';

  return (
    <HelmetProvider>
      <Helmet>
        <title>{title}</title>
        <meta property="og:title" content={title} />
        <meta name="twitter:title" content={title} />

        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta name="twitter:description" content={description} />

        <meta property="og:image" content={publicUrl + imageSrc} />
        <meta name="twitter:image" content={publicUrl + imageSrc} />
      </Helmet>
    </HelmetProvider>
  );
};

Metadata.displayName = 'Metadata';
